goog.provide('yext.storm.SmallBusinessOverview');
goog.provide('yext.storm.BusinessUpdates');
goog.provide('yext.storm.PowerListingReactivation');

goog.require('yext.storm.powerlistingstatus');
goog.require('yext.storm.routesDEPRECATED');
goog.require('yext.youtube');
goog.require('yext.location.MapMarkerView');

var {Spinner} = /** @type {SpinnerJS} */ (require('spin.js'));
require('spin.js/spin.css');

(function(window, document, undefined) {
  /**
   * @constructor
   */
  var SmallBusinessOverview = function() {
    var showBuySubscriptionButton = true;
    var showLocationSelector = true;

    // Sub modules for this page
    this.powerListingReactivation = new window.PowerListingReactivation();
    this.businessUpdates = new window.BusinessUpdates();
    this.powerListingStatus = new yext.storm.powerlistingstatus.PowerListingStatus(
      null, // locationId
      showBuySubscriptionButton,
      showLocationSelector);
    this.latestReviews = new LatestReviews();

    this.bindOptimizationTasks();
  };

  goog.exportSymbol('SmallBusinessOverview', SmallBusinessOverview);

  /**
   * Bind opted out button hover in the top optimization tasks section
   */
  SmallBusinessOverview.prototype.bindOptimizationTasks = function() {
    $('#optimization-tasks').on('mouseleave mouseenter', '.js-opted-out-wrap', function(e) {
      var $self = $(this);
      var mouseenter = e.type === 'mouseenter';

      $self.find('.js-opted-out').toggle(!mouseenter);
      $self.find('.js-opt-in').toggle(mouseenter);
    });
  };

  /**
   * Loads latest reviews pane with an AJAX call
   */
  var LatestReviews = function() {
    var $latestReviews = $('#latest-reviews');
    if ($latestReviews.length > 0) {
      $.ajax({
        url: yext.storm.routesDEPRECATED.SmallBusinessOverview.getReviews(),
        success: function(data) {
          $latestReviews.html(data);
        },
      });
    }
  };
})(window, document);

/**
 * Business Updates
 *
 * This module deals with the business updates section including generating
 * static maps for lat/long updates
 *
 *
 * @author matt@yext.com
 */
(function(window, document, undefined) {
  /**
   * @constructor
   *
   * Shows map loaders and adds mapquest maps
   */
  var BusinessUpdates = function() {
    this.generateMapImages();
    this.setupYoutubeVideos();
  };
  goog.exportSymbol('BusinessUpdates', BusinessUpdates);

  /**
   * Finds youtube video elements and shows a loader while preparing the
   * thumbnail then shows the video whe you click on it
   */
  BusinessUpdates.prototype.setupYoutubeVideos = function() {
    var self = this;

    $('.js-update-video').each(function() {
      var $this = $(this);
      var youtubeUrl = $this.data('youtube-url');
      var youtubeId = yext.youtube.parseIdFromUrl(youtubeUrl);

      if (youtubeId) {
        var spinner = new Spinner({
          length: 12,
          width: 3,
          radius: 9,
          color: '#000',
          hwaccel: true,
        });

        spinner.spin(this);

        yext.youtube.getVideosDetails([youtubeId], function(videos) {
          var video = videos[0];
          var img = new Image();

          img.onload = function() {
            spinner.stop();
            $(img).css('opacity', 0);
            $this.append(img).removeClass('update-video-loading');
            $(img).animate({opacity: 1});
          };

          img.src = video.thumbnail;
        });
      }
    });
  };

  /**
   * Generates map images using replaces loader with map images when they
   * are ready
   */
  BusinessUpdates.prototype.generateMapImages = function() {
    $('.js-map-marker').each(function() {
      new yext.location.MapMarkerView($(this));
    });
  };
}(window, document));

/**
 * Power Listing Reactivation
 *
 * This module handles the interaction surrounding the reactivation of a power
 * listing after it has expired
 *
 * TODO(mattjs) Remove old reactivation code when the new overview page goes live
 */
(function(window, document, undefined) {
  /**
   * @constructor
   *
   * Binds reactivation events if there are expired powerlistings
   */
  var PowerListingReactivation = function() {
    this.$reactivationDialog = $('#reactivation-dialog');
    this.$reactivateListing = $('.js-reactivate-listing');

    // Check that this is in error state and multiple locations need to be reactivated
    if (this.$reactivationDialog && this.$reactivateListing) {
      this.bindReactivateListing();
    }
  };

  goog.exportSymbol('PowerListingReactivation', PowerListingReactivation);

  /**
   * Binds click event to show the dialog that lists locations that need to
   * be reactivated and binds 'Ok' and 'Cancel' buttons on the dialog
   * @suppress {deprecated}
   */
  PowerListingReactivation.prototype.bindReactivateListing = function() {
    var self = this;

    this.$reactivationDialog.find('.primary').click(function() {
      self.redirectForReactivation();
    });

    this.$reactivationDialog.find('.cancel').click(function() {
      self.$reactivationDialog
        .hide()
        .dialog('destroy');
    });

    this.$reactivateListing.click(function() {
      self.$reactivationDialog
        .dialog({
          draggable: false,
          modal: true,
          resizable: false,
          minWidth: 300,
          width: 400,
        })
        .show();
    });
  };

  /**
   * Builds the location ids into query parameters and redirects to the add
   * subscriptions page for reactivating powerlistings
   */
  PowerListingReactivation.prototype.redirectForReactivation = function() {
    var locationIds = [];

    this.$reactivationDialog.find('input[type=checkbox]:checked').each(function() {
      locationIds.push($(this).val());
    });

    if (locationIds.length) {
      window.location.href = 'account/subscriptions/add?ids=' + locationIds.join();
    }
  };
})(window, document);
